import React from 'react';
import {browserHistory} from 'react-router';
import request from 'arcdynamic-request';
const buyerStateBreakdownRoute = '/buyer-state-breakdown';
const transactionBreakdownRoute = '/transaction-breakdown';
const marketTransactionBreakdownRoute = '/market-transaction-breakdown';
const marketShareRoute = '/market-share';
const listRoute = '/list';
import {MARKETS, TEAM, TERRITORIES_V2} from "../../consts/tables";
import { executeQuery } from '../../requests/executeQuery';
import { executeBackendQuery } from "../../requests/executeBackendQuery";
import { TERRITORY_AGENTS, GET_ASSIGNED_TERRITORIES_FOR_TEAM_MEMBER, GET_ALL_PRODUCT_TYPES, GET_ZIP_CODES_BY_TERRITORY } from '../../consts/queries';
import { getData, manageData } from '../../requests/CRUD';
import { normalizeListQuery, peakifyListQuery } from '../../utils';

export default class Filter extends React.Component {
	constructor(props) {
		super(props);
		// Normalized so a Target List link's `type` shows as the window it
		// stands for; otherwise the panel would open with blank date boxes
		// over a list that is in fact filtered.
		const query = {...normalizeListQuery(this.props.location.query)};

		this.state = {
			query,
			paneIndex: 0,
            buyerStateBreakdownCheckbox: false,
            transactionBreakdownCheckbox: false,
            marketTransactionBreakdownCheckbox: false,
            marketShareCheckbox: false,
            isBreakdown: false,
            items: [],
            team_members: [],
            productTypes: [],
            markets: [],
            territories: [],
            initialTerritoriesArray: {
                markets: [],
                territories: []
            }
        };

		this.clear = this.clear.bind(this);
		this.close = this.close.bind(this);
		this.setValue = this.setValue.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.getValuesForDropdown = this.getValuesForDropdown.bind(this);
        this.handleBreakdownChange = this.handleBreakdownChange.bind(this);
        this.navigateTo = this.navigateTo.bind(this);
        this.handlePaneChange = this.handlePaneChange.bind(this);
    }  
    
    static getDefaultQuery(page) {
		if (!page) {
			return {
                SOURCE: 'SUMMIT',
                STATUS: 'Active',
				TRANSACTION_TYPE: 'Investment Sales'
			}
		}

        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth()+1;
        const currentDay = today.getDate();
        const baseMin = `1/1/${currentYear}`;
        const baseMax = `${currentMonth}/${currentDay}/${currentYear}`;
        const comparisonMin = `1/1/${currentYear-1}`;
        const comparisonMax = `${currentMonth}/${currentDay}/${currentYear-1}`;

        switch (page) {
			case 'buyerStateBreakdown':
                return {
                    SOURCE: 'SUMMIT',
                    STATUS: 'Closed',
                    BASE_MIN: baseMin,
                    BASE_MAX: baseMax,
                    COMPARISON_MIN: comparisonMin,
                    COMPARISON_MAX: comparisonMax,
				};
			case 'transactionBreakdown':
                return {
                    STATE: 'TX',
                    TYPE: 'STNL',
                    STATUS: 'Closed',
					CATEGORY: 'retail',
                    TRANSACTION_YEAR: currentYear,
                };
            case 'marketTransactionBreakdown':
                return {
                    STATE: 'TX',
                    STATUS: 'Closed',
                    CATEGORY: 'retail',
					MARKET: 'DFW',
                    BASE_MIN: baseMin,
                    BASE_MAX: baseMax,
                    COMPARISON_MIN: comparisonMin,
                    COMPARISON_MAX: comparisonMax,
                };
            case 'marketShare':
                return {
                    STATE: 'TX',
                    STATUS: 'Closed',
                    TRANSACTION_TYPE: 'Investment Sales',
					CATEGORY: 'retail',
					MARKET: 'DFW',
                };
        }
    }

	async handleSubmit(e) {
		e.preventDefault();

		const query = {...this.state.query};
		const isBreakdown = this.state.isBreakdown;
        const buyerStateBreakdownCheckbox = this.state.buyerStateBreakdownCheckbox;
        const transactionBreakdownCheckbox = this.state.transactionBreakdownCheckbox;
        const marketTransactionBreakdownCheckbox = this.state.marketTransactionBreakdownCheckbox;
        const marketShareCheckbox = this.state.marketShareCheckbox;

		// Remove blank values
		Object.keys(query).forEach(key => {
			if (!query[key]) {
				delete query[key];
			}
            // if(key==='TERRITORY_LISTING_AGENT_TEAM'){
            //     delete query[key];
            // }
		});

		window.scrollTo(0, 0);

		// Product Type is a UI convenience for the property's real TYPE/CATEGORY
		// columns. Translate the selected product type(s) into TYPE/CATEGORY so the
		// list filters by the property's own type. PRODUCT_TYPE stays in the URL so
		// the filter popup can show what was selected, but it is NOT used as a filter:
		// routing sends product-type-only queries to V7 (Listing.js) and the V10
		// product slot is disabled (filter.js), so only TYPE/CATEGORY actually filter.
		if (query.PRODUCT_TYPE) {
			const categoryMap = { 'MT Retail': 'retail', 'Multi-Family': 'apartments', 'STNL Retail': 'retail' };
			const typeMap = { 'MT Retail': 'MT', 'STNL Retail': 'STNL' };
			const ids = String(query.PRODUCT_TYPE).split(',').map(s => s.trim()).filter(Boolean);
			const selected = (this.state.productTypes || []).filter(pt => ids.includes(pt.ARCIMEDES_ROW_ID));
			if (selected.length) {
				const categories = [...new Set(selected.map(pt => (categoryMap[pt.NAME] || pt.NAME).toLowerCase()))];
				const types = [...new Set(selected.map(pt => typeMap[pt.NAME]).filter(Boolean))];
				if (categories.length) query.CATEGORY = categories.join(',');
				if (types.length === 1) query.TYPE = types[0];
				else delete query.TYPE;
			}
		}

		// if Buyer State, Transaction Breakdowns or Market Share are activated
        if (buyerStateBreakdownCheckbox || transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox || marketShareCheckbox) {
            browserHistory.push({
                pathname: buyerStateBreakdownCheckbox ? buyerStateBreakdownRoute : transactionBreakdownCheckbox ? transactionBreakdownRoute : marketTransactionBreakdownCheckbox ? marketTransactionBreakdownRoute : marketShareRoute,
                query: peakifyListQuery(query),
            });
            return;
        }

        // if Buyer State, Transaction Breakdowns or Market Share are deactivated
        if (isBreakdown && (!buyerStateBreakdownCheckbox && !transactionBreakdownCheckbox && !marketTransactionBreakdownCheckbox && !marketShareCheckbox)) {
            this.setState({isBreakdown: !isBreakdown});
            browserHistory.push({
                pathname: listRoute,
                query: peakifyListQuery(query),
            });
            return;
        }

        // if STATUS = 'Under Contract' sort properties desc by EFFECTIVE_DATE
        if (query.STATUS === 'Under Contract')
            query.order = 'EFFECTIVE_DATE.desc';
        if (query.STATUS !== 'Under Contract' && query.order) {
            if (Array.isArray(query.order)) {
                const index = query.order.indexOf('EFFECTIVE_DATE.desc');
                if (index > -1) query.order.splice(index, 1);
            } else if (query.order === 'EFFECTIVE_DATE.desc') {
                delete query.order;
            }
        }

		// When territory filter is active, fetch ZIP codes before pushing URL
		// so TERRITORY_ZIP is always present in the query string.
		if (query.TERRITORY_LISTING_AGENT_TEAM || query.TERRITORY || query.TERRITORY_MARKET) {
			const zipString = await this.fetchTerritoriesZip();
			if (zipString) query.TERRITORY_ZIP = zipString;
		}

        
        browserHistory.push({
			pathname: this.props.location.pathname,
			query: peakifyListQuery(query),
		});
        if (this.refs.searchPanel) {
            this.refs.searchPanel.close();
        }
	}
    async fetchProductTypes(){
        //function to fetch product types
        const options = {
            "param": {},
        }
        return Promise.all([executeBackendQuery({ queryName: GET_ALL_PRODUCT_TYPES, options, expireTime: 1000 }),          
        ]).then(res => {         
            this.setState(prevObj => ({...prevObj, productTypes: res[0].data }))
            return res[0].data;
        });
    }
    async fetchMarkets(){
        // function to fetch markets
        return Promise.all([
            getData({tableCode: MARKETS})
        ]).then(res => {  
            this.setState(prevObj => ({...prevObj, initialTerritoriesArray: {...prevObj.initialTerritoriesArray, markets: res[0].data }}))
            return res[0].data;
        });
    }
    async fetchTerritories(){
        // function to fetch territories
        return Promise.all([
            getData({tableCode: TERRITORIES_V2})
        ]).then(res => {  
            this.setState(prevObj => ({...prevObj, initialTerritoriesArray: {...prevObj.initialTerritoriesArray, territories: res[0].data }}))
            return res[0].data;
        });
    }
    handleProductTypeChange(){
        const categoryMap = {
            "MT Retail": "retail",
            "Multi-Family": "apartments",
            "STNL Retail": "retail"
        };
        const typeMap = {
            "MT Retail": "MT",
            "STNL Retail": "STNL"
        };
        const selectedIds = (this.state.query.PRODUCT_TYPE || "").split(",").map(n => n.trim());
        const selectedProducts = (this.state.productTypes || []).filter(pt => selectedIds.includes(pt.ARCIMEDES_ROW_ID));
        const selectedNames = selectedProducts.map(pt => categoryMap[pt.NAME] || pt.NAME);      
        const selectedTypes = [...new Set(selectedProducts.map(pt => typeMap[pt.NAME]))];     
        // ARCIMEDES_ROW_ID is a string but MARKETS.PRODUCT_TYPE_ID is an integer (model
        // cast), so compare as strings — otherwise ["2"].includes(2) is false and the
        // market list (and therefore the pre-selected market value) comes back empty.
        const selectedTypeIds = selectedProducts.map(pt => String(pt.ARCIMEDES_ROW_ID));

        const filteredMarkets = (this.state.initialTerritoriesArray.markets || []).filter(market =>
            selectedTypeIds.includes(String(market.PRODUCT_TYPE_ID))
        );
        this.setState(prevObj => ({...prevObj, 
            query: {...prevObj.query, CATEGORY: selectedNames.join(",").toLowerCase(), TYPE: selectedTypes.join(",")},
            markets: filteredMarkets
        }))
    }

    handleMarketChange() {
        const selectedNames = (this.state.query.TERRITORY_MARKET || "").split(",").map(n => n.trim());
        // Compare as strings — TERRITORIES_V2.MARKET_ID is an integer (model cast) while
        // the selected market ids are strings, so a strict includes() would never match
        // and the territory list (and pre-selected territory value) would stay empty.
        const selectedTypeIds = (this.state.initialTerritoriesArray.markets || []).filter(pt => selectedNames.includes(String(pt.ARCIMEDES_ROW_ID))).map(pt => String(pt.ARCIMEDES_ROW_ID));
        const filteredTerritories = (this.state.initialTerritoriesArray.territories || []).filter(territory =>
            selectedTypeIds.includes(String(territory.MARKET_ID))
        );
        this.setState(prevObj => ({...prevObj, territories: filteredTerritories}))
    };
    fetchTerritoriesZip(){
        // function to fetch zip codes for each territory
        const ids = this.state.query.TERRITORY ? this.state.query.TERRITORY.split(',').filter(id => id) : []
        const marketIds = this.state.query.TERRITORY_MARKET ? this.state.query.TERRITORY_MARKET.split(',').filter(id => id) : []

        const territories_codes = this.state.initialTerritoriesArray.territories
        .filter(m => ids.includes(m.ARCIMEDES_ROW_ID))
        .map(m => m.CODE);

        // Send only the relevant parameter
        const params = territories_codes.length > 0
            ? { TERRITORY_CODES: territories_codes.join("|"), MARKET_IDS: "" }
            : { TERRITORY_CODES: "", MARKET_IDS: marketIds.join("|") };

        return Promise.all([
           executeQuery({queryName: GET_ZIP_CODES_BY_TERRITORY, params})
        ]).then(res => {
            if(res && res[0]){
                let zip_codes = res[0].data ? res[0].data.map(el => el.ZIP) : []
                const zipString = zip_codes.join(",");
                this.setState(prevState => ({...prevState, query: {...prevState.query, TERRITORY_ZIP: zipString}}))
                return zipString;
            }
            return "";
        })
    }
    async fetchMemberTerritories(id){
        try{
            const res = await executeBackendQuery({
                queryName: GET_ASSIGNED_TERRITORIES_FOR_TEAM_MEMBER,
                params: { TEAM_MEMBER_ID: id} 
            })
            if(res.data && res.data.length > 0){
                const productTypesOfMarkets = res.data.map(el => el.PRODUCT_TYPE_ID).filter((value, index, self) => self.indexOf(value) === index).join(',')
                const marketTypesOfTerritories = res.data.map(el => el.MARKET_ID).filter((value, index, self) => self.indexOf(value) === index).join(',')
                const territoriesOfMarkets = res.data.map(el => el.TERRITORY_ID).filter((value, index, self) => self.indexOf(value) === index).join(',')

                this.setState(prevState => ({...prevState, query: {...prevState.query, 
                    PRODUCT_TYPE: productTypesOfMarkets, 
                    TERRITORY_MARKET: marketTypesOfTerritories, 
                    TERRITORY: territoriesOfMarkets,
                }}))
            } else {
                this.setState(prevState => ({...prevState, query: {...prevState.query, PRODUCT_TYPE: "", TERRITORY_MARKET: "", TERRITORY: ""}}))
            }
        } catch (err) {
            this.setState({ error: err.message || "Failed to load territories" });
        }
    }
	componentDidMount() {
		const isBuyerStateBreakdown = this.props.location.pathname === buyerStateBreakdownRoute;
        const isTransactionBreakdown = this.props.location.pathname === transactionBreakdownRoute;
        const isMarketTransactionBreakdown = this.props.location.pathname === marketTransactionBreakdownRoute;
        const isMarketShare = this.props.location.pathname === marketShareRoute;
        const isBreakdown = isBuyerStateBreakdown || isTransactionBreakdown || isMarketTransactionBreakdown || isMarketShare;
        this.setState({
			isBreakdown,
			buyerStateBreakdownCheckbox: isBuyerStateBreakdown,
			transactionBreakdownCheckbox: isTransactionBreakdown,
            marketTransactionBreakdownCheckbox: isMarketTransactionBreakdown,
            marketShareCheckbox: isMarketShare
        });

        try {
            // Load all product types, markets, and territories once and reuse them as base datasets for state manipulation
            Promise.all([
                this.fetchProductTypes(),
                this.fetchMarkets(),
                this.fetchTerritories()
            ]).then((res) => {
                if (this.state.query.PRODUCT_TYPE) {
                    this.handleProductTypeChange();
                }
                if (this.state.query.TERRITORY_MARKET) {
                    this.handleMarketChange();
                    this.fetchTerritoriesZip()
                }

                if (this.state.query.TERRITORY) {
                    this.fetchTerritoriesZip();
                }
            });
            getData({
                tableCode: TEAM,
                options: {
                    filterType: 'and',
                    filter: [
                        // Only exclude deleted records; do not restrict by admin flag
                        { text: 'n', code: 'DELETED', type: 'exact' },
                        { text: 'a', code: 'IS_AGENT', type: 'exact' },
                    ],
                    column: [
                        "ARCIMEDES_ROW_ID",
                        "FIRST_NAME",
                        "LAST_NAME",
                        "TERMINATION_DATE",
                    ],
                    order: [
                        { code: 'LAST_NAME', type: 'asc' },
                        { code: 'FIRST_NAME', type: 'asc' },
                    ]
                }
            }).then((res) => {
                if(res.data){
                    // Drop terminated agents (e.g. the "Prior Agent" placeholder TEAM
                    // row, which always carries a TERMINATION_DATE) — same convention
                    // as SelectTeam/SelectTeam-new's `!x.TERMINATION_DATE` filter.
                    const activeAgents = res.data.filter((m) => !m.TERMINATION_DATE);
                    // SUMMIT Agent dropdown: order alphabetically by last name (then
                    // first name). Sorted client-side so the display order is guaranteed
                    // regardless of how the backend returns the rows.
                    const team_members = activeAgents.sort((a, b) => {
                        const lastA = (a.LAST_NAME || '').toLowerCase();
                        const lastB = (b.LAST_NAME || '').toLowerCase();
                        if (lastA !== lastB) return lastA < lastB ? -1 : 1;
                        const firstA = (a.FIRST_NAME || '').toLowerCase();
                        const firstB = (b.FIRST_NAME || '').toLowerCase();
                        return firstA < firstB ? -1 : firstA > firstB ? 1 : 0;
                    });
                    this.setState(prevObj => ({...prevObj, team_members}))
                }
            })
            Promise.all([
                executeQuery({queryName: TERRITORY_AGENTS}),
            ]).then((res) => {
                if(res && Array.isArray(res) && res.length>0){
                    let responseData = Array.isArray(res[0].data) ? res[0].data : [];
                    for(let property of responseData) {
                        property['AGENT_NAME'] = property['FIRST_NAME']+' '+property['LAST_NAME'];
                        delete property['FIRST_NAME'];
                        delete property['LAST_NAME'];
                    }
                    responseData = responseData.reduce((acc, curr) => {
                        const agent = acc.find(agent => agent.AGENT_ID === curr.AGENT_ID);
                        
                        if (agent) {
                            // If AGENT_ID already exists, concatenate the MARKET with a comma, avoiding duplicates
                            if (!agent.TERRITORY_MARKET.includes(curr.MARKET)) {
                                agent.TERRITORY_MARKET += `,${curr.MARKET}`;
                            }
                            if (!agent.PRODUCT_TYPE.includes(curr.TYPE)) {
                                agent.PRODUCT_TYPE += `,${curr.MARKET}`;
                            }
                            if (!(agent.TERRITORY || "").toString().includes(curr.TERRITORY)) {
                                agent.TERRITORY += `,${curr.TERRITORY}`;
                            }
                        } else {
                            // If AGENT_ID doesn't exist, create a new entry with MARKET as a string
                            acc.push({
                                ...curr,
                                TERRITORY_MARKET: curr.MARKET,
                                PRODUCT_TYPE: curr.TYPE,
                                TERRITORY: curr.TERRITORY
                            });
                        }
                        
                        return acc;
                    }, []);
                    let territoryDataItems = responseData ? responseData.filter(x => x.AGENT_NAME) : [];
                    this.setState({
                        items: Array.isArray(territoryDataItems) ? territoryDataItems : []
                    });
                    if(this.props.location.pathname === "/list"){
                        let paneIndex = Number(sessionStorage.getItem('lastClickedFilter'))?Number(sessionStorage.getItem('lastClickedFilter')):0;
                        this.setState({paneIndex})
                    }
                }
            })
        } catch (e) {
            console.error("error occurred", e);
        }
    }

	componentWillReceiveProps(nextProps) {
		if (this.props.location.query !== nextProps.location.query) {
            const isBuyerStateBreakdown = nextProps.location.pathname === buyerStateBreakdownRoute;
            const isTransactionBreakdown = nextProps.location.pathname === transactionBreakdownRoute;
            const isMarketTransactionBreakdown = nextProps.location.pathname === marketTransactionBreakdownRoute;
            const isMarketShare = nextProps.location.pathname === marketShareRoute;
            const isBreakdown = isBuyerStateBreakdown || isTransactionBreakdown || isMarketTransactionBreakdown || isMarketShare;
            const query = {...normalizeListQuery(nextProps.location.query)};
			delete query.page;
			this.setState({
				query,
				isBreakdown,
				buyerStateBreakdownCheckbox: isBuyerStateBreakdown,
                transactionBreakdownCheckbox: isTransactionBreakdown,
                marketTransactionBreakdownCheckbox: isMarketTransactionBreakdown,
                marketShareCheckbox: isMarketShare,
            });
        }
    }

    componentDidUpdate(prevProps, prevState){
        //Everytime market,product, or territor change, update params and options with the correrct values

        //  On change of the team member dropdown (step 6), fetch the territories assigned to that team member
        if(prevState.query.TERRITORY_LISTING_AGENT_TEAM !== this.state.query.TERRITORY_LISTING_AGENT_TEAM){
            this.fetchMemberTerritories(this.state.query.TERRITORY_LISTING_AGENT_TEAM)
        }

        //On product type selection, the markets dropdown is updated to display only markets belonging to the selected product types
        if(prevState.query.PRODUCT_TYPE !== this.state.query.PRODUCT_TYPE){
            this.handleProductTypeChange()
        }

        //On market selection, the territories dropdown is updated to display only territories belonging to the selected markets
        if(prevState.query.TERRITORY_MARKET !== this.state.query.TERRITORY_MARKET){
            this.handleMarketChange()
        }

        // On change of territory selection, fetch the ZIP codes for the selected territories
        if(prevState.query.TERRITORY !== this.state.query.TERRITORY){
            this.fetchTerritoriesZip()
        }
    }
    clear() {
        window.scrollTo(0, 0);
        browserHistory.push(this.props.location.pathname);
    }
    handleDropdownChange(query, optionType, value, valueKey, typeKey, reason, previousQuery) {
        const transactionBreakdown = this.state.transactionBreakdownCheckbox;
        
		
        if (valueKey === 'TYPE') {
            delete query.SINGLE_TENANT_SUBCATEGORY;
            delete query.MULTI_TENANT_SUBCATEGORY;
            delete query.TENANT_ID;
            delete query.LEASE_TYPE;
        }

        if (valueKey === 'TYPE' && transactionBreakdown) {
            if (query.TYPE === 'MT') {
                query.SOLD_PRICE_MIN = 400000;
                query.SQFT_MIN = 5000;
            } else {
                delete query.SOLD_PRICE_MIN;
                delete query.SOLD_PRICE_MAX;
                delete query.SQFT_MIN;
                delete query.SQFT_MAX;
            }
        }

        if (valueKey === 'MAIN_CATEGORY') {
            delete query.SUMMIT_YTD;
            delete query.SUMMIT_CLOSINGS;
            delete query.SUMMIT_NEGUC;
            delete query.SUMMIT_INVENTORY;
            const cat = query.MAIN_CATEGORY;
            delete query.MAIN_CATEGORY;
            if (cat) {
                query[cat] = 'true';
            }
        }

        if (valueKey === 'SOURCE' && (query[valueKey] === 'HSC' || query[valueKey] === 'PEAK')) {
            query.HSC_STATUS = 'Courting,Loan In Process';
            delete query.STATUS;
            delete query.TRANSACTION_TYPE;
        }
        if (valueKey === 'SOURCE' && (query[valueKey] === 'HSC' || query[valueKey] === 'PEAK') && (query.HSC_STATUS || '').includes('Closed')) {
            if(query.CLOSE_OF_ESCROW_MIN){
                delete query.CLOSE_OF_ESCROW_MIN
            }
            if(query.CLOSE_OF_ESCROW_MAX){
                delete query.CLOSE_OF_ESCROW_MAX
            }
        }
        if (valueKey === 'SOURCE' && query[valueKey] !== 'HSC' && query[valueKey] !== 'PEAK') {
            delete query.HSC_STATUS;
            delete query.LOAN_CLOSING_DATE_MIN;
            delete query.LOAN_CLOSING_DATE_MAX;
            delete query.MATURITY_DATE_MIN;
            delete query.MATURITY_DATE_MAX;
        }
        

        if(valueKey === 'TERRITORY_LISTING_AGENT_TEAM' && reason === null){
            if(query.hasOwnProperty('TERRITORY_LISTING_AGENT_TEAM')) delete query.TERRITORY_LISTING_AGENT_TEAM
            delete query.TERRITORY_MARKET
            delete query.PRODUCT_TYPE
            delete query.TERRITORY
        }else if(valueKey === 'TERRITORY_LISTING_AGENT_TEAM'){
            query.TERRITORY_MARKET = reason['TERRITORY_MARKET']
            query.PRODUCT_TYPE = reason['PRODUCT_TYPE']
            query.TERRITORY = reason['TERRITORY']
        }
        // Pane 5 is Territories (the index was 4 before the Peak pane was inserted
        // ahead of it, which left this branch pointing at a pane with no STATUS).
        if(this.state.paneIndex === 5 && valueKey === 'STATUS'){
            const status = query.STATUS || '';
            if (!status.includes('Active')){
                delete query.LISTED_DATE_MIN;
                delete query.LISTED_DATE_MAX;
            }
            if (!status.includes('Closed')){
                delete query.CLOSE_OF_ESCROW_MIN;
                delete query.CLOSE_OF_ESCROW_MAX;
            }
        }

        this.setState({ previousQuery:previousQuery, query });
    }

    handleChange(key, value) {
        const q = {
            [key]: value
        };

        if (key === 'TYPE') {
            q.SINGLE_TENANT_SUBCATEGORY = null;
            q.MULTI_TENANT_SUBCATEGORY = null;
            q.TENANT_ID = null;
            q.LEASE_TYPE = null;
        }

        this.setState({
            query: Object.assign(this.state.query, q),
        });
    }

    handleBreakdownChange(name) {
        const breakdownCheckbox = !this.state[name];
        let page = null;
        let query;

        switch (name) {
			case 'buyerStateBreakdownCheckbox':
				page = breakdownCheckbox ? 'buyerStateBreakdown' : null;
				query = Filter.getDefaultQuery(page);
				this.setState({query, buyerStateBreakdownCheckbox: breakdownCheckbox});
				break;
            case 'transactionBreakdownCheckbox':
                page = breakdownCheckbox ? 'transactionBreakdown' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({query, transactionBreakdownCheckbox: breakdownCheckbox});
                break;
            case 'marketTransactionBreakdownCheckbox':
                page = breakdownCheckbox ? 'marketTransactionBreakdown' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({query, marketTransactionBreakdownCheckbox: breakdownCheckbox});
                break;
            case 'marketShareCheckbox':
                page = breakdownCheckbox ? 'marketShare' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({query, marketShareCheckbox: breakdownCheckbox});
                break;
		}
    }

	setValue(updates) {
		this.setState({query: {...this.state.query, ...updates}});
	}

	close() {
		this.refs.searchPanel.close();
	}
	openFilter() {
		this.refs.searchPanel.open();
	}

	getValuesForDropdown(query, options, key, type='multiple') {
		if (!query || !options || query.length === 0 ) {
			return [];
        }

		let formattedQueryValues = query.split(',');
		let response = [];
		options.forEach((el) => {
			if (!key) {
				if (formattedQueryValues.includes(el)) {
					response.push(el)
				}
			} else {
				if (formattedQueryValues.includes(el[key])) {
					response.push(el)
				}
			}
		});

		if (!response) {
			return [];
        }
		if (type === "multiple") {
			return response;
		}
		return response[0] ? response[0] : null;
	}

    navigateTo(pathname) {
        const {isBreakdown, query} = this.state;
        if (isBreakdown) {
            const q = Filter.getDefaultQuery();
            this.setState({
				query: q,
				isBreakdown: !isBreakdown,
				buyerStateBreakdownCheckbox: false,
				transactionBreakdownCheckbox: false,
                marketTransactionBreakdownCheckbox: false,
                marketShareCheckbox: false,
            });
            browserHistory.push({
                pathname,
                query: q,
            });
            return;
        }

        browserHistory.push({
            pathname: pathname,
            query: peakifyListQuery(query),
        });
	}

    // Stepping between filter panes only changes which pane is on screen. It used
    // to drop TERRITORY_LISTING_AGENT_TEAM / TERRITORY / PRODUCT_TYPE /
    // TERRITORY_MARKET on the way out of one pane and push that stripped query
    // straight to the URL, which left TERRITORY_ZIP behind on its own. With those
    // four gone the list routes to the plain V7 query (Listing.js), and V7 has no
    // TERRITORY_ZIP slot — so opening MISC to add "Modified By = Crawler" replaced
    // the territory search with an unscoped one instead of narrowing it. Territory
    // filters are cleared where the user actually clears them: the SUMMIT Agent
    // dropdown in handleDropdownChange.
    handlePaneChange(key){
        this.setState({paneIndex: key})
        sessionStorage.setItem('lastClickedFilter', key);
    }
}
